// Meta Pixel browser helpers + Conversions API event_id generation
// Pixel base code is injected in /public/index.html; this module only
// fires standard events and ensures we attach a shared event_id so
// CAPI server-side events (sent from the Stripe webhook) can dedupe.

const EVENT_ID_KEY = "dp_meta_event_id";
const PURCHASE_FIRED_KEY = "dp_meta_purchase_fired";

export function newEventId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `e_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

/**
 * Fire a Meta Pixel standard event.
 * Pass eventId so it can dedupe with the server-side CAPI event.
 */
export function mpTrack(eventName, params = {}, eventId) {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  try {
    if (eventId) {
      window.fbq("track", eventName, params, { eventID: eventId });
    } else {
      window.fbq("track", eventName, params);
    }
  } catch {
    /* no-op */
  }
}

export function setCheckoutEventId(id) {
  try {
    localStorage.setItem(EVENT_ID_KEY, id);
  } catch {
    /* no-op */
  }
}

export function getCheckoutEventId() {
  try {
    return localStorage.getItem(EVENT_ID_KEY) || null;
  } catch {
    return null;
  }
}

export function clearCheckoutEventId() {
  try {
    localStorage.removeItem(EVENT_ID_KEY);
    localStorage.removeItem(PURCHASE_FIRED_KEY);
  } catch {
    /* no-op */
  }
}

/**
 * Fire Purchase only once per session_id to avoid double-counting
 * if the user refreshes the success page.
 */
export function firePurchaseOnce(sessionId, eventId, params) {
  if (!sessionId || !eventId) return;
  try {
    const fired = localStorage.getItem(PURCHASE_FIRED_KEY);
    if (fired === sessionId) return;
    mpTrack("Purchase", params, eventId);
    localStorage.setItem(PURCHASE_FIRED_KEY, sessionId);
  } catch {
    mpTrack("Purchase", params, eventId);
  }
}
